import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_ROOT_API,
    headers: {
        'Content-Type': 'multipart/form-data'
    }
});

// Interceptor para adicionar o token Authorization automaticamente
axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default axiosInstance;